import React from "react";

import { Filter } from "@planzone/dto";
import { Calendar } from "@scenes/calendar";
import { useCalendarData } from "@scenes/calendar/useCalendarData";
import { usePreferences } from "@components/preferences";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectCalendarPage({ project }: Props) {
  const { state, edit } = usePreferences();
  const filter = state.projectCalendarFilter;
  const setFilter = (nextFilter: Filter) =>
    edit({ ...state, projectCalendarFilter: { ...filter, ...nextFilter } });

  const calendarFilter = React.useMemo(
    () => ({
      projects: [project],
      resources: filter.resources,
      elementTypes: filter.elementTypes,
      scope: "PROJECT" as const,
    }),
    [project.uuid, filter.resources, filter.elementTypes],
  );

  const {
    cursor,
    setCursor,
    planzone,
    hasPlanzone,
    isRequestPending,
    events,
    tasks,
    calendar,
    weeks,
    currentWeek,
  } = useCalendarData(calendarFilter);

  return (
    <div className={styles.calendarPage}>
      <Calendar
        date={cursor}
        events={events}
        milestones={calendar.milestones}
        tasks={tasks}
        editDate={setCursor}
        zones={[]}
        isRequestPending={isRequestPending}
        month={weeks}
        currentWeek={currentWeek}
        renderDay={(date, events) => (
          <div>
            {events.map((event) => (
              <div key={event.uuid}>
                <p>{event.name}</p>
              </div>
            ))}
          </div>
        )}
        planzone={planzone}
        hasPlanzone={hasPlanzone}
        filter={filter}
        setFilter={setFilter}
        project={project}
        scope="project"
      />
    </div>
  );
}

export { ProjectCalendarPage };
